import React from 'react';

class Interrupter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const {children, bgColor} = this.props;
        return (
            <div className="interrupter p-3 d-flex justify-content-center uppercase" style={{backgroundColor: bgColor}}>
                {children}
            </div>
        );
    }
};

export default Interrupter;


// WEBPACK FOOTER //
// ./src/pages/components/page/Interrupter.js